export default {
  ROUNDED_NUMBER: 'ROUNDED_NUMBER',
  WHOLE_NUMBER: 'WHOLE_NUMBER',
  DATE: 'DATE',
  BOOLEAN: 'BOOLEAN',
  ARRAY: 'ARRAY',
  DATE_TIME: 'DATE_TIME',
};
